export const qbElementTypeNames = [
  'Account',
  'Vendor',
  'Service',
  'Part',
  'Tax Code',
  'Customer Type',
  'Terms',
  'Customer',
  'Estimate',
  'Invoice',
  'Payment',
  'Tax',
  'PartInventory_Deprecated',
  'Contact',
  'Invoice Line',
  'Estimate Line',
  'Payment Type'
];

export default qbElementTypeNames;



// WEBPACK FOOTER //
// ./src/helpers/constants.js